module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "our_academic_model.788cf7fd.png";